export class Zone {

    zne_id: string;
    zne_pay_id: string;
    zne_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.zne_id         = data['zne_id'] ? data['zne_id'] : null;
        this.zne_pay_id     = data['zne_pay_id'] ? data['zne_pay_id'] : null;
        this.zne_libelle    = data['zne_libelle'] ? data['zne_libelle'] : null;
    }

}
